import React from 'react';
import './partesAtomicas.scss';

const BotonAtomico = ({ tipo='button', isDisabled=false, label='', labelColor = '#fff', colorCorp = 1, onClick=null }) => {
  const backgrounds = ['#F67500', '#00657D'];
  //backgrounds[0] = naranjo, backgrounds[1] = azul

  const estilo = {
    color: labelColor ,
    background: backgrounds[colorCorp]
  }

  const click = () => {

    if(!isDisabled){
      onClick()
    }
  }

  return (
    <button
      type={tipo}
      onClick={click}
      style={estilo}
      className={`botonAtomico ${isDisabled ? "desactivado" : ""}`}
    >
      {/* {icon} */}
      {label}
    </button>
  );
};

export default BotonAtomico;
